import CONSTANTS from '../constants';

export default class ScrollHelper {
  previous = null;
  timer = null;

  static onScroll() {
    const sections = document.querySelectorAll('.items');
    const menuLinks = document.querySelectorAll('.category');
    if (menuLinks.length > 0 && sections.length > 0) {
      const current = [...sections].findIndex((section) => {
        return (
          window.scrollY + CONSTANTS.CLUTTER <
          section.offsetTop + section.offsetHeight - CONSTANTS.NAVBAR_HEIGHT
        );
      });
      let isStop = true;
      if (current > -1) {
        if (current !== this.previous && current > 0) {
          this.previous = current;
          let event = new CustomEvent('category-changed');
          document.dispatchEvent(event);
        }
        [...Array(sections.length).keys()].forEach((link) => {
          menuLinks[link].classList.remove('active');
        });

        menuLinks[current].classList.add('active');

        if (this.timer !== null) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          document.getElementById('categories').scrollTo({
            left: menuLinks[current].offsetLeft - 150,
            top: 0,
            behavior: 'smooth'
          });
        }, 150);
        menuLinks[current].focus();
      }
    }
  }

  static scrollTo(event, layoutType) {
    if (event?.target?.classList?.contains('category')) {
      let category = event.target;
      let element = document.querySelector(`[data-category-id=${category.id}]`);
      if (layoutType === 'default') {
        this.scroll(element.offsetTop - 63);
      } else if (layoutType === 'old') {
        this.scroll(element.offsetTop - 50);
      }
    }
  }

  static scroll(top) {
    window.scrollTo({
      left: 0,
      top: top,
      behavior: 'smooth'
    });
  }
}
